<template>
  <div class="topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle1"
    >
      <span
        class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"
        >سلام,</span
      >
      <span
        class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
        >{{ this.user.name }}</span
      >
      <span class="symbol symbol-35 symbol-light-success">
        <img alt="Pic" :src="picture" />
        <!-- <span v-if="true" class="symbol-label font-size-h5 font-weight-bold"></span> -->
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
      >
        <h3 class="font-weight-bold m-0">
          اطلاعات کاربری
          <!-- <small class="text-muted font-size-sm ml-2">12 messages</small> -->
        </h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative;"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5">
            <!-- <img class="symbol-label" :src="picture" alt />
            <b-icon  class="symbol-badge bg-success" icon="pen"></b-icon>-->

            <div
              class="image-input image-input-outline"
              id="kt_user_add_avatar"
            >
              <div
                class="image-input-wrapper"
                v-bind:style="{ backgroundImage: 'url(' + picture + ')' }"
              ></div>
              <label
                @click="changePicture"
                class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                data-action="change"
                data-toggle="tooltip"
                title="تغییر عکس"
                data-original-title="تغییر عکس"
              >
                <avatarChanger
                  v-model="user.image_profile"
                  v-bind:fileUploaded="fileUploaded"
                ></avatarChanger>
                <i class="fa fa-pen icon-sm text-muted"></i>
              </label>
              <span
                class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                data-action="cancel"
                data-toggle="tooltip"
                title="Cancel avatar"
              >
                <i class="ki ki-bold-close icon-xs text-muted"></i>
              </span>
            </div>
          </div>
          <div class="d-flex flex-column">
            <a
              href="#"
              class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
              >{{ this.user.name }}</a
            >
            <!-- <div class="text-muted mt-1">Application Developer</div> -->
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-icon mr-1">
                    <span class="svg-icon svg-icon-lg svg-icon-primary">
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/Communication/Call.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <span class="navi-text text-muted text-hover-primary">{{
                    this.user.mobile
                  }}</span>
                </span>
              </a>
            </div>
            <button class="btn btn-light-primary btn-bold" @click="onLogout">
              خروج
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <!--begin::Nav-->
        <div class="navi navi-spacer-x-0 p-0">
          <!--begin::Item-->
          <a
            @click="hideMenu"
            href="/user/my"
            class="navi-item nav-item-close-links"
            id="nav-item-close-links_1"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      src="media/svg/icons/General/Notification2.svg"
                    />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">اطلاعات کاربری</div>
                <div class="text-muted">
                  نمایش و ویرایش اطلاعات کاربری
                  <!-- <span
                    class="label label-light-danger label-inline font-weight-bold"
                  >بروزرسانی</span>-->
                </div>
              </div>
            </div>
          </a>
          <!--end:Item-->
          <!--begin::Item-->
          <a
            @click="hideMenu"
            href="/user/changePass"
            class="navi-item nav-item-close-links"
            id="nav-item-close-links_2"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-warning">
                    <!--begin::Svg Icon-->
                    <inline-svg src="media/svg/icons/Shopping/Chart-bar1.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">تغییر رمز عبور</div>
                <div class="text-muted">تغییر رمز عبور برای ورود به پنل</div>
              </div>
            </div>
          </a>
          <!--end:Item-->
          <!--begin::Item-->
          <a
            @click="hideMenu"
            href="/user/changeNotification"
            class="navi-item nav-item-close-links"
            id="nav-item-close-links_3"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-warning">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      src="media/svg/icons/General/Notifications1.svg"
                    />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">تنظیم اعلانات</div>
                <div class="text-muted">تنظیم اعلانات بخش های مختلف</div>
              </div>
            </div>
          </a>
          <!--end:Item-->
          <!--begin::Item-->
          <!-- <a href="/user/conf" class="navi-item">
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-danger">
                    <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">تایید اطلاعات کاربری</div>
                <div class="text-muted">تایید اطلاعات کاربری برای دریافت درگاه</div>
              </div>
            </div>
          </a>-->
          <!--end:Item-->
        </div>
        <!--end::Nav-->
        <div class="separator separator-dashed my-7"></div>
        <!--begin::Notifications-->
        <div>
          <!--begin:Heading-->
          <!-- <h5 class="mb-5">آخرین اطلاعیه ها</h5> -->
          <!--end:Heading-->
          <template v-for="(item, i) in list">
            <!--begin::Item -->
            <div
              class="d-flex align-items-center rounded p-5 gutter-b"
              v-bind:class="`bg-light-${item.type}`"
              v-bind:key="i"
            >
              <span
                class="svg-icon mr-5"
                v-bind:class="`svg-icon-${item.type}`"
              >
                <span class="svg-icon svg-icon-lg">
                  <!--begin::Svg Icon-->
                  <inline-svg :src="item.svg" />
                  <!--end::Svg Icon-->
                </span>
              </span>
              <div class="d-flex flex-column flex-grow-1 mr-2">
                <a
                  href="#"
                  class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1"
                  >{{ item.title }}</a
                >
                <span class="text-muted font-size-sm">{{ item.desc }}</span>
              </div>
              <span
                class="font-weight-bolder py-1 font-size-lg"
                v-bind:class="`text-${item.type}`"
                >{{ item.alt }}</span
              >
            </div>
            <!--end::Item -->
          </template>
        </div>
        <!--end::Notifications-->
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import httpHelper from "@/helpers/httpHelper";
import avatarChanger from "@/components/avatarChanger";
import sessionHelper from "@/helpers/sessionHelper";
import routesMap from '@/helpers/routesMap';
export default {
  name: "KTQuickUser",
  components: {
    avatarChanger,
  },
  data() {
    return {
      user: {},
      picture: "media/users/default.jpg",
      list: [
        // {
        //   title: "طراحی پنل جدید",
        //   desc: "2 روز پیش",
        //   alt: "+28%",
        //   svg: "media/svg/icons/Home/Library.svg",
        //   type: "warning"
        // }
      ],
      routesMap,
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    // Get User Data
    // ApiService.setHeader();
    // ApiService.get("users/verify", "").then(res => {
    //   this.user = res.data;
    // });
    httpHelper.setAuth();
    httpHelper.getData("users/verify").then((res) => {
      this.user = res;
      if (this.user.image_profile != null && this.user.image_profile != "") {
          httpHelper.getImage(this.user.image_profile).then((res) => {
            this.picture = res.result.url
          });
      }
      // sessionHelper.setUser(res);
      // if (
      //   this.user.phonestatus == 1520 ||
      //   this.user.nationalstatus == 1520 ||
      //   this.user.selfiestatus == 1520
      // ) {
      //   this.$router.push("/user/conf");
      // }
    });
  },
  methods: {
    hideMenu() {
      KTLayoutQuickUser.get_offcanvasObject().hide();
    },
    onLogout() {
      localStorage.clear();
      this.$router.push({ name: "login" });
    },
    changePicture() {
    },
    fileUploaded() {
        httpHelper.getImage(this.user.image_profile).then((res) => {
          this.picture = res.result.url
        });
      httpHelper
        .postData("users/ChangeImageProfile", {
          image_profile: this.user.image_profile,
        })
    },
  },
  computed: {
    // picture() {
    //   return process.env.BASE_URL + "media/users/300_21.jpg";
    // }
  },
};
</script>
